module.exports = __webpack_public_path__ + "assets/img/download-btn-ef9af43a.png";